import styled, { css } from 'styled-components';
import { dropShadow } from '../../../../styles/Layout';
import { ThemeColours } from '../../../../styles/ThemeColours';
import { FONT_STACK, PRESSABLE } from '../../../../styles/constants';
import { Link } from '../../../Link';
import { IconLogout } from '../../../icons/IconLogout';

export const UserMenuView = styled.div`
  ${FONT_STACK};
  padding-top: 8px;
  position: absolute;
  right: 0;

  &.enter {
    opacity: 0.01;
  }

  &.enter-active {
    opacity: 1;
    transition: opacity 0.3s;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0.01;
    transition: opacity 0.3s;
  }
`;

export const Menu = styled.div`
  background-color: ${ThemeColours.white};
  border-radius: 2px;
  ${dropShadow};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  width: 184px;
`;

const linkStyle = css`
  ${PRESSABLE};
  align-items: center;
  color: ${ThemeColours.black};
  font-size: 14px;
  margin: 8px 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const MenuLink = styled(Link)`
  ${linkStyle}
  line-height: 22px;
`;

export const LogoutLink = styled.div`
  ${linkStyle}
  display: flex;
  justify-content: space-between;
`;

export const Divider = styled.div`
  background-color: ${ThemeColours.mono100};
  height: 1px;
  margin: 8px 0;
`;

export const Icon = styled(IconLogout)`
  fill: currentColor;
  height: 16px;
  width: 16px;
`;
